const TYPES = {
  CHILD: "child",
  DEFAULT: "default",
  PARTNERS: "partners",
};

export { TYPES };
